import WorkerMessageType from "./WorkerMessageType"

/**
 * @description: Bridge between main and worker
 */
class ControlsProxy {

    /**
     * @param {Worker} worker
     * @param coreThread
     * @param {HTMLElement | null} htmlElement
     * @param {String} [elementID] default value: element
     * @return {void} void
     */
    constructor(worker, coreThread, htmlElement = null, elementID = 'element') {

        if (!(worker instanceof Worker)) {
            throw new Error('ControlsProxy: the first parameter "worker" is not assignable to type Worker.')
        }

        this.worker = worker
        this.htmlElement = htmlElement
        this.coreThread = coreThread
        this.elementID = elementID

        if (htmlElement !== null) {
            if (!(htmlElement instanceof HTMLElement)) {
                throw new Error('ControlsProxy: the second parameter "htmlElement" is not assignable to type HTMLElement.')
            } else {
                this.worker.postMessage({
                    type: WorkerMessageType.MAKE_ELEMENT,
                    id: elementID
                })
            }
        }

    }

    /**
     * @description: pick Object keys by String[]
     * @param {Object} src Object
     * @param {String[]} properties
     * @return {Object} Object
     */
    static copyProperties(src, properties) {
        const result = {}
        properties.forEach(key => {
            result[key] = src[key]
        })
        return result
    }

    /**
     * @description children must override createInit()
     * @param {OffscreenCanvas} offscreenCanvas
     * @return {void}
     */
    createInit(offscreenCanvas) {
        this.worker.postMessage({
            type: WorkerMessageType.CREATE_INIT,
            id: this.elementID,
            canvas: offscreenCanvas
        }, [offscreenCanvas])
    }

    /**
     * @abstract
     */
    configEventListener() {
        // children must override listenerToEvent()
    }

    /**
     * @param {{type:string,id:string,event:any}} event
     * @return {vodi} void
     */
    sendEventMessage(event) {
    }

    /**
     * @abstract
     */
    dispose() {
        this.worker.postMessage({
            type: WorkerMessageType.DISPOSE
        })
    }

}

export default ControlsProxy
